import statsig from "statsig-js";
import { FeatureFlagProvider, UserContext } from "./FeatureFlagProvider";

export default class StatsigProvider extends FeatureFlagProvider {
  constructor(sdkKey, environment) {
    super(sdkKey, environment);
    this.statsigClient = statsig;
  }

  async initialize(user = new UserContext()) {
    if (!this.sdkKey) {
      throw new Error("Statsig SDK Key is missing. Cannot initialize Statsig.");
    }
    
    if (this.statsigClient.initializeCalled()) {
      // Shutdown the existing client if it's already initialized
      // Used to force refresh of feature flags cache
      this.statsigClient.shutdown();
    }

    await this.statsigClient.initialize(
      this.sdkKey,
      {
        userID: user.userID,
        email: user.email,
      },
      {
        environment: {
          tier: this.environment,
        },
      }
    );
  }

  async getFeatureFlagValue(key, defaultValue) {
    if (!this.statsigClient.initializeCalled()) {
      console.warn("Statsig not initialized. Returning default value for", key);
      return defaultValue;
    }
    return this.statsigClient.checkGate(key);
  }
}
